import {del, get, post, put} from "../util/http.service";

export const apiGetSites = params => ({
  queryKey: ["sites", params],
  queryFn: () => get("/api/sites", params),
  placeholderData: (previousData) => previousData
});

export const apiCreateSite = () => ({
  mutationFn: data => post("/api/sites", data)
});

export const apiUpdateSite = siteId => ({
  mutationFn: data => put("/api/sites/" + siteId, data)
});

export const apiDeleteSite = () => ({
  mutationFn: siteId => del("/api/sites/" + siteId)
});

export const apiGetSiteDetails = siteId => ({
  queryKey: ["site_details_" + siteId],
  queryFn: () => get("/api/sites/" + siteId)
});

export const apiGetSiteEvents = siteId => ({
  queryKey: ["site_events_" + siteId],
  queryFn: () => get("/api/sites/" + siteId + "/events")
});

export const apiGetSiteContacts = siteId => ({
  queryKey: ["site_contacts_" + siteId],
  queryFn: () => get("/api/sites/" + siteId + "/contacts")
});

export const apiUpdateSiteContacts = siteId => ({
  mutationFn: data => put("/api/sites/" + siteId + "/contacts", data)
});

export const apiGetSitePrestations = siteId => ({
  queryKey: ["site_prestations_" + siteId],
  queryFn: () => get("/api/sites/" + siteId + "/prestations")
});

export const apiCreateSitePrestation = siteId => ({
  mutationFn: data => post("/api/sites/" + siteId + "/prestations", data)
});

export const apiUpdateSitePrestation = (siteId, prestationId) => ({
  mutationFn: data => put("/api/sites/" + siteId + "/prestations/" + prestationId, data)
});

export const apiDeleteSitePrestation = (siteId, prestationId) => ({
  mutationFn: () => del("/api/sites/" + siteId + "/prestations/" + prestationId)
});

export const apiGetSiteFiles = siteId => ({
  queryKey: ["site_files_" + siteId],
  queryFn: () => get("/api/sites/" + siteId + "/files")
});

export const apiCreateSiteFile = siteId => ({
  mutationFn: data => post("/api/sites/" + siteId + "/files", data)
});

export const apiDeleteSiteFile = siteId => ({
  mutationFn: fileId => del("/api/sites/" + siteId + "/files/" + fileId)
});

export const apiGetSiteProgressReports = siteId => ({
  queryKey: ["site_progress_reports_" + siteId],
  queryFn: () => get("/api/sites/" + siteId + "/progress-reports")
});

export const apiCreateSiteProgressReport = siteId => ({
  mutationFn: data => post("/api/sites/" + siteId + "/progress-reports", data)
});

export const apiUpdateSiteProgressreport = (siteId, progressReportId) => ({
  mutationFn: data => put("/api/sites/" + siteId + "/progress-reports/" + progressReportId, data)
});

export const apiDeleteSiteProgressReport = (siteId, progressReportId) => ({
  mutationFn: () => del("/api/sites/" + siteId + "/progress-reports/" + progressReportId)
});
